import React from "react";
import "./Footer.css";
import designSvg from "../../assets/design.svg.png";

const Footer = () => {
    return (
        <div className="footer-div">
            <a


                href="https://www.clarusway.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
            >
                <code className="brand">{"<Clarusway/> "}</code>
            </a>
            <img
                src={designSvg}
                alt="design"
                style={{ width: "40px", margin: "0  25px 0 10px" }}
            />
            <span>design</span>
        </div>
    );
};

export default Footer;